import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Authenticate } from '../authenticate/authenticate';
import { Attachment } from './attachment';
import { AT } from './AT';


@Injectable({ providedIn: 'root' })
export class AttachmentService {
  auth: Authenticate;
  constructor(private http: HttpClient) { }

  // DELETE ATTACHEMENT FROM DB
  deleteAttachment(attachment: Attachment, jwt: string): Observable<any> {

    let options = {
      headers: new HttpHeaders(
        {
          "Authorization": "Bearer " + jwt, "Content-Type": "application/x-www-form-urlencoded"
        }),
      body: attachment,
    };
    const urld = environment.appURL + "/attachments/" + attachment.id;
    const urlupload = environment.appURL + "/upload/files/" + attachment.refId;
    this.http.delete(urlupload, options);
    return this.http.delete<Attachment>(urld, options);

  }

  // DELETE UPLOADED FILE FROM HARD DISK MEDIA LIBRARY
  deleteUpload(attachment: Attachment, jwt: string): Observable<any> {
    const url = environment.appURL + "/upload/files/" + attachment.refId;
    return this.http.delete<any>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }


  // ADD ATTACHMNET DATABASE
  addAttach(att: string, id: number, userid: number, attmime: string, attname: string, attsize: string, refID: number) {
    var upd = "{\"data\": \"" + att + "\", \"ticket\": \"" + id +
      "\" , \"user\": \"" + userid +
      "\" , \"mime\": \"" + attmime +
      "\"  , \"name\": \"" + attname + "\",\"size\": \"" + attsize + "\",\"refId\": \"" + refID + "\"}";

    let _at = new AT;
    _at.data = att;
    _at.ticket = id;
    _at.user = userid;
    _at.mime = attmime;
    _at.name = attname
    _at.size = attsize;
    _at.refId = refID;

    var upd2 = JSON.stringify(_at);
    console.log("this UPD = " + upd);
    return this.http.post(environment.appURL + "/attachments", upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('updateStatus'))
      );
  }

  // ADD ATTACHMENT
  addAttachUrl(att: FormData) {
    var tk = "Bearer " + environment.token;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': tk,
      })
    };
    return this.http.post<any>(environment.appURL + "/upload", att, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(
      tap(_ => console.log(`Attachment Added`)),
      catchError(this.handleError<any>('updateStatus'))

    );
  }

  // ERROR HANDLER
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure      console.log(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
